import * as React from "react";

import { cn } from "@/lib/utils";

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="off"
        autoSave="off"
        type={type}
        data-slot="input"
        className={cn(
          "file:text-foreground border-b placeholder:text-[#677e7e] text-sm border-input h-9 w-full min-w-0 px-3 py-1 font-thin shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
          "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
          "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
          type === "checkbox" ? "min-h-[1.4rem]" : "min-h-[41px]",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
